/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, May 7th 2022, 3:13:11 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { useGlobalScope } from "core/providers";
import { useOnboardingContext } from "onboarding/providers/OnboardingProvider";
import { ContinueSetupCTA } from "onboarding/components/ContinueSetupCTA";
import { SubscriptionPendingCTA } from "saas-subscription/components/SubscriptionPendingCTA";
import { SubscriptionExpiredCTA } from "saas-subscription/components/SubscriptionExpiredCTA";
import { UnavailableOrganizationAlert } from "organizations/components/UnavailableOrganizationAlert";
import { UndefinedOrganizationStatusAlert } from "organizations/components/UndefinedOrganizationStatusAlert";
import { DeactivatedOrganizationAlert } from "organizations/components/DeactivatedOrganizationAlert";

export const AdminPortalProvisioningController = ({ children }) => {
  const {
    globalState: { selectedOrganization },
  } = useGlobalScope();

  const {
    onboardingState: { isReadyToSubscribe },
  } = useOnboardingContext();

  const allowAccess = !selectedOrganization || selectedOrganization?.organization_status === "active";

  let fallbackComponent: React.ReactNode;

  switch (selectedOrganization?.organization_status) {
    case "active":
      fallbackComponent = null;
      break;

    case "pending":
      if (isReadyToSubscribe) {
        fallbackComponent = <SubscriptionPendingCTA organizationName={selectedOrganization?.name} />;
      } else {
        fallbackComponent = <ContinueSetupCTA organizationName={selectedOrganization?.name} />;
      }
      break;

    case "deactivated":
      fallbackComponent = <DeactivatedOrganizationAlert organization={selectedOrganization} />;
      break;
    case "suspended":
      fallbackComponent = <SubscriptionExpiredCTA organization={selectedOrganization} />;
      break;
    case "blacklisted":
      fallbackComponent = <UnavailableOrganizationAlert organizationName={selectedOrganization?.name} />;
      break;
    default:
      fallbackComponent = <UndefinedOrganizationStatusAlert organizationName={selectedOrganization?.name} />;
  }

  return <>{allowAccess ? children : fallbackComponent}</>;
};
